export const cloneObj = (obj: Object) => (obj ? JSON.parse(JSON.stringify(obj)) : null);
